/**
 * Canonical user-facing semver for the buxus-apps product line (4.x).
 *
 * **Single edit point** for web UI, analytics `app_version`, Bugsnag, and `apps/web/package.json`.
 * `vite build` fails if `package.json` `version` does not match this constant.
 *
 * Bump here for coordinated releases (web now; monorepo mobile later). Keep at 4.0.0 until the
 * new web app is stable — release cadence TBD.
 */
export const BUXUS_APP_DISPLAY_VERSION = "4.0.0";
/** Public site href (legacy `SITE_URI`). */
export const BUXUS_SITE_URL = "https://www.buxus.io";
/** Link label matching legacy mobile `CONTACT_CONDENSED_URI`. */
export const BUXUS_SITE_CONDENSED_LABEL = "www.Buxus.io";
